export const getFooterText = () => {
  const date = new Date();
  return `© ${date.getFullYear()} SoyRappi Inc.`;
}